import {useCallback, useEffect, useState} from "react";
import {makeApiCall, makeApiCallPost} from "../../../Api/makeApiCall";
import {getSingleRowActionQueryParams} from "./helpers";
import {toastError} from "../../../utils/toast";
import {toast} from "react-toastify";

export function useServiceBase({ endpointUrl, endpointUrlForPost, urlContainsParams }) {
    if (!endpointUrlForPost) {
        endpointUrlForPost = endpointUrl;
    }
    if (!urlContainsParams){
        urlContainsParams = false
    }
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [triggerRefresh, setTriggerRefresh] = useState(Date.now());

    useEffect(() => {
        if (endpointUrl) {
            setLoading(true);
            makeApiCall(endpointUrl).then((result) => {
                setData(result);
                setLoading(false);
            });
        }
    }, [endpointUrl, triggerRefresh]);

    function handlePostResponse(response, shouldThrowError= false ) {
        if (response?.apiError) {
            toastError(toast, `Operation failed with api error "${JSON.stringify(response.apiError.message)}"`)
            setLoading(false)
            if(shouldThrowError){
                throw new Error(`API request failed with API error "${JSON.stringify(response.apiError.message)}"`);
            }
        } else {
            setTriggerRefresh(Date.now())
        }
    }

    function onRowEditConfirmed(currentData) {
        return makeApiCallPost(endpointUrlForPost + getSingleRowActionQueryParams("update", urlContainsParams), currentData)
            .then((responseData) => {
                handlePostResponse(responseData, true)
            });
    }

    function onBulkRowUploadConfirmed(currentData) {
        setLoading(true)
        return makeApiCallPost(endpointUrlForPost + getSingleRowActionQueryParams("update", urlContainsParams) + '&multiple_submits=true', currentData)
            .then(handlePostResponse)
            .finally(() => setLoading(false));
    }

    function onRowDeleteConfirmed(currentData) {
        setLoading(true);
        return makeApiCallPost(endpointUrlForPost + getSingleRowActionQueryParams("delete", urlContainsParams), currentData)
            .then(handlePostResponse)
            .finally(() => setLoading(false));
    }
    function onDeleteAllConfirmed(currentData) {
        setLoading(true);
        return makeApiCallPost(endpointUrlForPost + "deleteAllData", currentData)
            .then(handlePostResponse)
            .finally(() => setLoading(false));
    }

    const refreshData = useCallback(() => setTriggerRefresh(Date.now()), []);

    return {
        loading,
        setLoading,
        data,
        onRowEditConfirmed,
        onRowDeleteConfirmed,
        onDeleteAllConfirmed,
        onBulkRowUploadConfirmed,
        refreshData
    };
}